import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, HostListener, OnInit, OnDestroy, Inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { WorkSheet, WorkBook, utils, read, writeFile } from "xlsx";
import { Papa } from "ngx-papaparse";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { GridActionsService } from "../grid-actions.service";
import { AuthService } from "../../services/auth.service";
import {SnackbarComponent} from '../../components/snackbar/snackbar.component';

@Component({ 
  selector: "app-bulk-import",
  templateUrl: "./bulk-import.component.html",
  styleUrls: ["./bulk-import.component.scss"],
})
export class BulkImportComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private papa: Papa,
    private dialogRef: MatDialogRef<BulkImportComponent>,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private gridActionsService: GridActionsService
  ) {}
  tableData: any;
  extention: string;
  validExtention:boolean = false;
  isHovered: boolean;
  actions: any;
  private destroy$ = new Subject<void>();
  uploadData: any;

  ngOnInit(): void {
    if (!this.tableData) this.actions = [{ text: "Download template" }];
  }

  @HostListener("dragover", ["$event"]) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isHovered = true;
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isHovered = false;
  }

  @HostListener("drop", ["$event"]) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.handleFileInput(evt.dataTransfer.files);
    }
  }

  uploadFile() {}

  dropFile() {
    this.uploadFile();
  }

  clickToUpload() {
    this.uploadFile();
  }
  handleFileInput(event) {
    if (typeof event === "object") {
      this.validExtention = false;
      const file = event[0];
      this.extention = file.name.split(".")[file.name.split(".").length - 1];

      const allowedExtensions = ["CSV", "XLSX", "XLSM"];
      if (allowedExtensions.includes(this.extention.toUpperCase())) {
        this.validExtention = true;
        const reader = new FileReader(); 
        reader.readAsArrayBuffer(file);
        reader.onload = (e) => {
          let data;
          const arrayBuffer:any = e.target.result;
          const uint8Array = new Uint8Array(arrayBuffer);
          var string = new TextDecoder().decode(uint8Array);
          if (this.extention.toUpperCase() === "CSV") {
            data = this.parseFromCsv(string);
          } else if (
            this.extention.toUpperCase() === "XLSX" ||
            this.extention.toUpperCase() === "XLSM"
          ) {
            data = this.parseFromExcel(string);
          } else {
          }
          if (
            data.length === 1 &&
            !Object.values(data[0])
              .map((res) => typeof res === "string" && isNaN(+res))
              .includes(false)
          ) {
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'File contains header row only, please try again',
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
          } else {
            this.tableData = data;
            this.uploadData = {
              tableData : this.tableData,
              isPriceSettings: this.data?.isPriceSettings
            }
          }
        };
        reader.onerror = function (evt) {
        };
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Please upload csv or xlsx file',
                action: 'Dismiss',
                type: 'info',
              },
            }
        );
      }
    }
  }

  parseFromCsv(file) {
    const parsedData = this.papa.parse(file, {
      complete: (result: any) => {},
    });

    const returnArray = parsedData.data.filter((element) => {
      if (!(element.length === 1 && element[0] === "")) {
        return Object.assign({}, element);
      }
    });
    return returnArray;
  }

  parseFromExcel(file) {
    const workbook: WorkBook = read(file, { type: "binary" });
    const wsname: string = workbook.SheetNames[0];
    const ws: WorkSheet = workbook.Sheets[wsname];
    const tableData = utils.sheet_to_csv(ws);
    return this.parseFromCsv(tableData);
  }

  emitAction(event): void {
    if (event === "Download template") {
      this.downloadTemplate();
    } else if (event == "Cancel") this.dialogRef.close();
    else {
      this.gridActionsService.changedEvent$.next(event);
    }
  }

  downloadTemplate(): void {
    const header = [["Sku", "Min Price", "PricingOn"], []];
    if(this.data.isPriceSettings){
      header[0] = ["Sku", "Min Price","Repricing model", "Repricing(On/Off)","Min Price(Auto/Manual)" , "Prep Cost", "Ship Cost","Cost","Max Price","Max Price(Auto/Manual)","MarkUp","Min MarkUp","Default Price","Map Price", "Map Price(On/Off)"]
    } else {
      this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res.isShipyard !== null) {
          header[0].push("Case Qty")
          header[0].push("Upc")
          header[0].push("Note")
          header[0].push("Expirable")
          header[0].push("Prep Cost")
          header[0].push( "Ship Cost")
        };
        if (res.isPriceYard !== null)
          header[0] = [
            ...header[0],
            ...[
              "Cost",
              "Max Price",
              "Markup",
              "Min Markup",
              "Default Price",
              "Repricing model",
              "MAP enforce",
             
             
            ],
          ];
      });
      header[0].push("Sync Inventory")
      header[0].push("Max Sync Qty")
      header[0].push("IsActive")
      header[0].push("Length")
      header[0].push("Width")
      header[0].push("Weight")
      header[0].push("Height")
      header[0].push("Map Price")
    }

    const ws: WorkSheet = utils.aoa_to_sheet(header);
    const wb: WorkBook = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");
    writeFile(wb, "template.csv");
  }

  close() {
    this.dialogRef.close();
  }
  actionChanged(e) {
    this.actions = e;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}